import React from 'react'
import { TrendingDown, ArrowUpRight, ArrowDownRight, Minus } from 'lucide-react'
import { formatPercent } from '../utils/format'

const LEVEL_COLOR = {
  low: 'var(--onds-bull)',
  elevated: 'var(--onds-caution)',
  high: 'var(--onds-bear)',
  extreme: 'var(--onds-bear)',
}

const TREND_ICON = {
  rising: ArrowUpRight,
  falling: ArrowDownRight,
  flat: Minus,
}

function Metric({ label, value, color }) {
  return (
    <div className="rounded-xl p-3 border" style={{ backgroundColor: 'var(--onds-surface)', borderColor: 'var(--onds-border)' }}>
      <p className="text-[10px] uppercase tracking-wider text-[var(--onds-text-dim)] mb-1">{label}</p>
      <p className="text-base font-bold tabular-nums" style={{ color: color ?? 'var(--onds-text)' }}>{value}</p>
    </div>
  )
}

export default function ShortInterestPanel({ shortInterest }) {
  if (!shortInterest || (!shortInterest.summary && !shortInterest.thesis)) return null

  const level = (shortInterest.level ?? '').toLowerCase()
  const levelColor = LEVEL_COLOR[level] ?? 'var(--onds-text-dim)'
  const trend = (shortInterest.trend ?? '').toLowerCase()
  const TrendIcon = TREND_ICON[trend] ?? Minus

  return (
    <div className="onds-card p-5 md:p-6">
      <div className="flex items-center justify-between gap-3 mb-3 flex-wrap">
        <div className="flex items-center gap-2">
          <TrendingDown className="h-5 w-5" style={{ color: 'var(--onds-accent)' }} />
          <h2 className="text-lg font-bold">Short Interest</h2>
          <span className="text-sm text-[var(--onds-text-dim)]">who is short and why</span>
        </div>
        {shortInterest.level && (
          <span className="onds-chip" style={{ color: levelColor, borderColor: `${levelColor}55`, backgroundColor: `${levelColor}14` }}>
            {shortInterest.level} short interest
          </span>
        )}
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-4">
        <Metric label="% of float" value={shortInterest.percentFloat != null ? formatPercent(shortInterest.percentFloat, 1) : '—'} color={levelColor} />
        <Metric label="Days to cover" value={shortInterest.daysToCover ? shortInterest.daysToCover.toFixed(1) : '—'} />
        <Metric label="Trend" value={<span className="inline-flex items-center gap-1"><TrendIcon className="h-4 w-4" />{shortInterest.trend || '—'}</span>} />
        <Metric label="Squeeze risk" value={shortInterest.squeezeRisk || '—'} />
      </div>

      {shortInterest.thesis && (
        <div className="rounded-xl p-4 border mb-3" style={{ backgroundColor: 'var(--onds-surface)', borderColor: 'var(--onds-border)' }}>
          <p className="text-[11px] uppercase tracking-wider mb-1" style={{ color: 'var(--onds-bear)' }}>The short thesis</p>
          <p className="text-sm text-[var(--onds-text)] leading-relaxed">{shortInterest.thesis}</p>
        </div>
      )}

      {shortInterest.changeNote && (
        <p className="text-sm text-[var(--onds-text-dim)] leading-relaxed mb-1"><span className="font-semibold text-[var(--onds-text)]">Change: </span>{shortInterest.changeNote}</p>
      )}
      {shortInterest.summary && (
        <p className="text-sm text-[var(--onds-text-dim)] leading-relaxed">{shortInterest.summary}</p>
      )}
      {shortInterest.asOf && (
        <p className="text-[11px] text-[var(--onds-text-dim)] mt-2">As of {shortInterest.asOf}</p>
      )}
    </div>
  )
}
